import { TranslatableText } from '@dreryk/react-common';
import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalMaxHeight,
   ModalWidth,
   ValidateFormEventInterceptor,
} from '@dreryk/react-components';

import { VideoConsultationPatientContactUpdateShowModalEventInterceptor } from '~libs.desktop.video-consultation';

import { AppointmentWaitlistForm } from '../../shared/waitlist/AppointmentWaitlistForm';
import { AppointmentUpdateFormController } from '../shared/AppointmentUpdateForm';

import { AppointmentWaitlistUpdateFormLoader } from './AppointmentWaitlistUpdateForm.loader';
import { appointmentWaitlistUpdateFormInitializer } from './AppointmentWaitlistUpdateModal.utils';

type AppointmentWaitlistUpdateModalConfirmButtonRenderer = (
   renderProps: Pick<AppointmentUpdateFormController, 'handleSubmit'>
) => JSX.Element;

type AppointmentWaitlistUpdateModalProps = {
   readonly onClose: VoidFunction;
   readonly appointmentId: number;
   readonly title: TranslatableText;
   readonly confirmButton: AppointmentWaitlistUpdateModalConfirmButtonRenderer;
};

// eslint-disable-next-line max-lines-per-function
export const AppointmentWaitlistUpdateModal = (props: AppointmentWaitlistUpdateModalProps): JSX.Element => {
   return (
      <Modal testId={'updateAppointmentModal'} title={props.title} width={ModalWidth.WIDE} height={ModalMaxHeight.TALL}>
         <AppointmentWaitlistUpdateFormLoader appointmentId={props.appointmentId}>
            {({ appointmentDetails, practitioners, healthcareProviderLocations, patient, waitlistEntry }) => (
               <AppointmentWaitlistForm
                  appointmentId={appointmentDetails.id}
                  initializer={appointmentWaitlistUpdateFormInitializer(
                     appointmentDetails,
                     healthcareProviderLocations,
                     patient
                  )}
                  practitioners={practitioners}
                  healthcareProviderLocations={healthcareProviderLocations}
                  waitlistEntry={waitlistEntry}
                  patientCreateAllowed
               >
                  {({ getValue, handleSubmit, formState, trigger }) => {
                     const patientId = getValue('patient')?.id ?? null;
                     const videoConsultationEnabled = Boolean(getValue('videoConsultation'));

                     return (
                        <>
                           <ValidateFormEventInterceptor trigger={trigger} silent>
                              <VideoConsultationPatientContactUpdateShowModalEventInterceptor
                                 patientId={patientId}
                                 shouldShowModal={videoConsultationEnabled}
                              >
                                 {props.confirmButton({
                                    handleSubmit: handleSubmit,
                                 })}
                              </VideoConsultationPatientContactUpdateShowModalEventInterceptor>
                           </ValidateFormEventInterceptor>
                           <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                           <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                        </>
                     );
                  }}
               </AppointmentWaitlistForm>
            )}
         </AppointmentWaitlistUpdateFormLoader>
      </Modal>
   );
};
